export enum DocumentationURL {
  AZURE = 'https://docs.deeploy.ml/next/installation/azure',
  AWS = 'https://docs.deeploy.ml/next/installation/aws',
  GCP = 'https://docs.deeploy.ml/next/installation/gcp',
  OVHCLOUD = 'https://docs.deeploy.ml/next/installation/ovhcloud',
  SCALEWAY = 'https://docs.deeploy.ml/next/installation/scaleway',
}
